/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';
import { ETransportModifVehMessageVO } from './etransport-modif-veh-message-vo.model';
import { ETransportConfirmationMessageVO } from './etransport-confirmation-message-vo.model';
import { ETransportMessageVO } from './etransport-message-vo.model';
import { Column, ColumnsInterface } from '@irian-ro/util-table';
import { FilterMatchMode } from 'primeng/api';

export class ETransportListMessageVO extends JSONable{

  uuid: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.type',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  tip: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.status',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  stare: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.uit',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  uit: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.declarationCode',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  codDecl: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.declarationReference',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  refDecl: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.postDamage',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  postAvarie: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.source',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  sursa: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.loadId',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  idIncarcare: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.creationDate',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
  })
  dataCreare: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.modificationDate',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
  })
  dataModif: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.operationType',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  tipOp: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.transportDate',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
  })
  dataTransp: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.pickupCountry',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  pcTara: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.pickupCode',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  pcCod: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.pickupName',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  pcDen: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.deliveryCountry',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  trTara: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.deliveryCode',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  trCod: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.deliveryName',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  trDen: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.vehicleModificationDate',
    filterType: 'calendar',
    filterMatchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
  })
  dataModifVeh: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.vehicleNumber',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  nrVeh: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.trailer1Number',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  nrRem1: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.trailer2Number',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  nrRem2: Maybe<string> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.lineCount',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  nrLinii: Maybe<number> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.totalNetWeight',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  grTotNeta: Maybe<number> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.totalGrossWeight',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  grTotBruta: Maybe<number> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.totalValue',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  valTot: Maybe<number> | undefined = undefined;

  @Column({
    header: 'etransport.declarant.list.confirmation',
    filterType: 'input',
    filterMatchMode: FilterMatchMode.CONTAINS,
  })
  confirmare: Maybe<ETransportConfirmationMessageVO> | undefined = undefined;

  modifVeh: ETransportModifVehMessageVO[] = [];
  mesaje: ETransportMessageVO[] = [];

  static _columns: ColumnsInterface[] | undefined = undefined;
}
